exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-body>p{margin-bottom:0}.severity{font-size:10px;border:1px solid #000}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/alert_success.vue"],"names":[],"mappings":"AACA,cACE,eAAiB,CAClB,AACD,UACE,eAAgB,AAChB,qBAAuB,CACxB","file":"alert_success.vue","sourcesContent":["\n.modal-body > p {\n  margin-bottom: 0;\n}\n.severity {\n  font-size: 10px;\n  border: 1px solid #000;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31f304d8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/alert_success.vue
// module id = 1080
// module chunks = 1 2